module.exports = __webpack_public_path__ + "static/sbinvest-banner-3ce63abe402ec731ba26805b3b91609e.png";